import { brighten, getValue } from "../../utils.js";

export const APP_MATRIX = {
  "Matrix.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Matrix.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Matrix.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Matrix.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Matrix.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Matrix.Border.Color": {
    ref: "Color.Transparent"
  },
  "Matrix.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Matrix.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Matrix.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Matrix.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Matrix.Padding.Top": {
    defaultValue: "0px"
  },
  "Matrix.Padding.Right": {
    defaultValue: "0px"
  },
  "Matrix.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Matrix.Padding.Left": {
    defaultValue: "0px"
  },
  "Matrix.Shadow": {
    defaultValue: "none"
  },
  "Matrix.Shadow.Type": {
    defaultValue: "none"
  },
  "Matrix.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Matrix.Card.Gap": {
    ref: "Space.12"
  },
  "Matrix.Row.Separator.Color": {
    ref: "Color.Gray.300"
  },
  "Matrix.Row.Column.Header.Bg.Color": {
    ref: "Color.Primary.100",
    referredIn: ["Matrix.Row.Column.Header.Hover.Bg.Color"]
  },
  "Matrix.Row.Column.Header.Border.Color": {
    ref: "Color.Primary.200"
  },
  "Matrix.Row.Column.Header.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Matrix.Row.Column.Header.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Matrix.Row.Column.Header.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Matrix.Row.Column.Header.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Matrix.Row.Column.Header.Border.Top.Left.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Row.Column.Header.Border.Top.Right.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Row.Column.Header.Border.Bottom.Left.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Row.Column.Header.Border.Bottom.Right.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Row.Column.Header.Color": {
    ref: "Color.Gray.800"
  },
  "Matrix.Row.Column.Header.Font.Size": {
    ref: "Font.Size.14"
  },
  "Matrix.Row.Column.Header.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Matrix.Row.Column.Icon.Color": {
    ref: "Color.Gray.300"
  },
  "Matrix.Row.Column.Header.Hover.Bg.Color": {
    valueFunc: (meta) => {
      return brighten(getValue("Matrix.Row.Column.Header.Bg.Color", meta), 0.5);
    }
  },
  "Matrix.Card.Bg.Color": {
    ref: "Color.White"
  },
  "Matrix.Card.Border.Color": {
    ref: "Color.Transparent"
  },
  "Matrix.Card.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Matrix.Card.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Matrix.Card.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Matrix.Card.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Matrix.Card.Border.Top.Left.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Card.Border.Top.Right.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Card.Border.Bottom.Left.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Card.Border.Bottom.Right.Radius": {
    defaultValue: "8px"
  },
  "Matrix.Card.Shadow.Type": {
    ref: "Shadow.100.Pos"
  },
  "Matrix.Card.Shadow.Color": {
    ref: "Shadow.Color"
  },
  "Matrix.Card.Title.Font.Size": {
    ref: "Font.Size.14"
  },
  "Matrix.Card.Title.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Matrix.Card.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Matrix.Card.Hover.Bg.Color": {
    ref: "Color.White"
  },
  "Matrix.Card.Hover.Border.Color": {
    ref: "Color.Gray.400"
  },
  "Matrix.Card.Hover.Shadow.Type": {
    ref: "Shadow.100.Pos"
  },
  "Matrix.Card.Hover.Shadow.Color": {
    ref: "Shadow.Color"
  },
  "Matrix.Subitem.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Matrix.Subitem.Border.Color": {
    ref: "Color.Gray.200"
  },
  "Matrix.Subitem.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Matrix.Subitem.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Matrix.Subitem.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Matrix.Subitem.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Matrix.Subitem.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Matrix.Subitem.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Matrix.Subitem.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Matrix.Subitem.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Matrix.Subitem.Title.Font.Size": {
    ref: "Font.Size.14"
  },
  "Matrix.Subitem.Title.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Matrix.Subitem.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Matrix.Subitem.Hover.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Matrix.Subitem.Hover.Border.Color": {
    ref: "Color.Gray.400"
  },
  "Matrix.Width": {
    defaultValue: "100%"
  },
  "Matrix.Height": {
    defaultValue: "500px"
  },
  "Matrix.Overflow": {
    defaultValue: "hidden"
  },
  "Matrix.Min.Height": {
    defaultValue: "0px"
  },
  "Matrix.Max.Height": {
    defaultValue: "unset"
  },
  "Matrix.Min.Width": {
    defaultValue: "750px"
  },
  "Matrix.Max.Width": {
    defaultValue: "unset"
  },
  "Matrix.Margin.Top": {
    defaultValue: "0px"
  },
  "Matrix.Margin.Right": {
    defaultValue: "0px"
  },
  "Matrix.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Matrix.Margin.Left": {
    defaultValue: "0px"
  },
  "Matrix.Border.Style": {
    defaultValue: "solid"
  },
  "Matrix.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Matrix.Cursor": {
    defaultValue: "pointer"
  }
};
